export default __webpack_public_path__ + "static/media/chevron-down.0a95b5ea.svg";